import { render, staticRenderFns } from "./BillReactivationModal.vue?vue&type=template&id=4f0630d2&"
import script from "./BillReactivationModal.vue?vue&type=script&lang=js&"
export * from "./BillReactivationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports